const TARGET = 'bookingmodal';

export const bookingmodal = {
    init: () => {
        document.addEventListener('click', (e) => {
            const target = e.target;
            if (target instanceof HTMLAnchorElement && target.target === TARGET) {
                /** @var AnchorElement e.target */
                e.preventDefault();
                const url = target.href;

                // Create DOM
                const closeBtn = document.createElement('button');
                closeBtn.classList.add('bookingmodal__close', 'button', 'button--secondary', 'button--icon', 'icon--before', 'icon--close');

                const iframe = document.createElement('iframe');

                const innerWrapper = document.createElement('div');
                innerWrapper.className = 'bookingmodal__frame';
                innerWrapper.append(closeBtn, iframe);

                const wrapper = document.createElement('div');
                wrapper.className = 'bookingmodal';
                wrapper.append(innerWrapper);

                document.body.append(wrapper);
                document.body.classList.add('no-scroll');

                // Callbacks
                const closeModalFn = () => {
                    document.body.classList.remove('no-scroll');
                    wrapper.remove();
                    window.removeEventListener('message', onMessageFn);
                }
                const onMessageFn = (event) => {
                    if (event.origin !== document.location.origin) {
                        return;
                    }

                    if (event.data === 'bookingmodal_contentloaded') {
                        // TODO improve loading experiency by showing a loader until the iframe content was loaded?
                    }
                    else if (event.data === 'bookingmodal_close') {
                        closeModalFn();
                    }
                }

                // Add Events
                closeBtn.addEventListener('click', closeModalFn);
                window.addEventListener('message', onMessageFn);

                // Load iframe content after the modal was added to the DOM
                iframe.src = url;
            }
        });
    }
};
